import { LENDING_PARAMETER_GUARANTEES, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { EMPLOYEE_ROLES } from "@/components/employees/forms/employee_category_filter";
import {
  REQUEST_GET_COUNTRIES,
  RECEIVE_GET_COUNTRIES,
  RECEIVE_GET_COUNTRIES_ERROR,
  RECEIVE_GET_STATES_ERROR,
  RECEIVE_GET_STATES,
  REQUEST_GET_STATES,
  REQUEST_GET_CURRENCIES,
  RECEIVE_GET_CURRENCIES,
  RECEIVE_GET_CURRENCIES_ERROR,
  REQUEST_GET_TIME_ZONES,
  RECEIVE_GET_TIME_ZONES,
  RECEIVE_GET_TIME_ZONES_ERROR,
  RECEIVE_GET_GUARANTEES,
  RECEIVE_GET_EMPLOYEE_ROLES,
  REQUEST_GET_LOAN_PROGRAMS,
  RECEIVE_GET_LOAN_PROGRAMS,
  RECEIVE_GET_LOAN_PROGRAMS_ERROR,
  REQUEST_SET_TIME_ZONES,
} from "../constants/parameters";
import * as parameterApi from "../../api/parameters";
import { showNotification } from "./notification";

const notificationPayload = {
  message: {
    title: "Saved",
    description: "",
    options: {
      variant: NOTIFICATION_VARIANTS.SUCCESS,
    },
  },
};

function requestGetLoanPrograms() {
  return {
    type: REQUEST_GET_LOAN_PROGRAMS,
  };
}

function receiveGetLoanPrograms(loanPrograms) {
  return {
    type: RECEIVE_GET_LOAN_PROGRAMS,
    loanPrograms,
  };
}

function receiveGetLoanProgramsError(error) {
  return {
    type: RECEIVE_GET_LOAN_PROGRAMS_ERROR,
    error,
  };
}

export function fetchLoanPrograms() {
  return async function (dispatch) {
    dispatch(requestGetLoanPrograms());
    const response = await parameterApi.fetchLoanPrograms();
    if (response.ok) {
      dispatch(receiveGetLoanPrograms(response.data));
    } else {
      dispatch(receiveGetLoanProgramsError(response.userDescription));
      dispatch(
        showNotification({
          ...notificationPayload,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}

function requestGetCountries() {
  return {
    type: REQUEST_GET_COUNTRIES,
  };
}

function receiveGetCountries(countries) {
  return {
    type: RECEIVE_GET_COUNTRIES,
    countries,
  };
}

function receiveGetCountriesError(error) {
  return {
    type: RECEIVE_GET_COUNTRIES_ERROR,
    error,
  };
}

export function fetchCountries() {
  return async function (dispatch) {
    dispatch(requestGetCountries());
    const response = await parameterApi.fetchCountries();
    if (response.ok) {
      dispatch(receiveGetCountries(response.data));
    } else {
      dispatch(receiveGetCountriesError(response.userDescription));
      dispatch(
        showNotification({
          ...notificationPayload,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}

function requestGetStates() {
  return {
    type: REQUEST_GET_STATES,
  };
}

function receiveGetStates(states) {
  return {
    type: RECEIVE_GET_STATES,
    states,
  };
}

function receiveGetStatesError(error) {
  return {
    type: RECEIVE_GET_STATES_ERROR,
    error,
  };
}

export function fetchStates(countryId) {
  return async function (dispatch) {
    dispatch(requestGetStates());
    const response = await parameterApi.fetchStates(countryId);
    if (response.ok) {
      dispatch(receiveGetStates(response.data.items));
    } else {
      dispatch(receiveGetStatesError(response.userDescription));
      dispatch(
        showNotification({
          ...notificationPayload,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}

function requestGetCurrencies() {
  return {
    type: REQUEST_GET_CURRENCIES,
  };
}

function receiveGetCurrencies(currencies) {
  return {
    type: RECEIVE_GET_CURRENCIES,
    currencies,
  };
}

function receiveGetCurrenciesError(error) {
  return {
    type: RECEIVE_GET_CURRENCIES_ERROR,
    error,
  };
}

export function fetchCurrencies() {
  return async function (dispatch) {
    dispatch(requestGetCurrencies());
    const response = await parameterApi.fetchCurrencies();
    if (response.ok) {
      dispatch(receiveGetCurrencies(response.data));
    } else {
      dispatch(receiveGetCurrenciesError(response.userDescription));
      dispatch(
        showNotification({
          ...notificationPayload,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}

function requestGetTimeZones() {
  return {
    type: REQUEST_GET_TIME_ZONES,
  };
}

function receiveGetTimeZones(timeZones) {
  return {
    type: RECEIVE_GET_TIME_ZONES,
    timeZones,
  };
}

function receiveGetTimeZonesError(error) {
  return {
    type: RECEIVE_GET_TIME_ZONES_ERROR,
    error,
  };
}

export function fetchTimeZones() {
  return async function (dispatch) {
    dispatch(requestGetTimeZones());
    const response = await parameterApi.fetchTimeZones();
    if (response.ok) {
      dispatch(receiveGetTimeZones(response.data));
    } else {
      dispatch(receiveGetTimeZonesError(response.userDescription));
      dispatch(
        showNotification({
          ...notificationPayload,
          message: {
            title: "Error",
            description: response.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
    }
  };
}

function requestSetTimeZones(timeZones) {
  return {
    type: REQUEST_SET_TIME_ZONES,
    timeZones,
  };
}

export function setTimeZones(timeZones) {
  return function (dispatch) {
    dispatch(requestSetTimeZones(timeZones));
  };
}

function receiveGetGuarantees(guarantees) {
  return {
    type: RECEIVE_GET_GUARANTEES,
    guarantees,
  };
}

export function fetchGuarantees() {
  return function (dispatch) {
    const guarantees = Object.keys(LENDING_PARAMETER_GUARANTEES).map(item => ({
      value: item,
      label: LENDING_PARAMETER_GUARANTEES[item],
    }));
    dispatch(receiveGetGuarantees(guarantees));
  };
}

function receiveGetEmployeeRoles(employeeRoles) {
  return {
    type: RECEIVE_GET_EMPLOYEE_ROLES,
    employeeRoles,
  };
}

export function fetchEmployeeRoles() {
  return function (dispatch) {
    const employeeRoles = Object.keys(EMPLOYEE_ROLES).map(item => ({
      value: item,
      label: EMPLOYEE_ROLES[item].NAME,
      description: EMPLOYEE_ROLES[item].DESCRIPTION,
    }));
    dispatch(receiveGetEmployeeRoles(employeeRoles));
  };
}
